import React, {useEffect} from "react";
import Tag from "../../assets/tag.png";
import User from "../../assets/user.png";
import { useLocation, useNavigate } from "react-router-dom";
import TopChoice from "../../Templates/DetailPage/TopChoice";
import { useContext } from "react";
import {stateContext} from "../../App";


function Detail({navigation}) {
  const navigate = useNavigate();
  const {state} = useLocation();

  let objofA = [
    { title: "Monthly Visitors", value: "89.1B" },
    { title: "Monthly Visitors", value: "89.1B" },
    { title: "Monthly Visitors", value: "89.1B" },
    { title: "Monthly Visitors", value: "89.1B" },
    { title: "Monthly Visitors", value: "89.1B" },
  ];

  const {setShowModal} = useContext(stateContext);


  useEffect((
  ) => {
    if(state === null)
    {
      navigate("/");
    }
  }, [state])

  return (
    <div>
      <div className="grid grid-cols-12 md:gap-10 gap-0 lg:px-20 md:px-10 px-2 mt-10">
        <div className="md:col-span-8 col-span-12">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img src={state?.img && require(`../../assets/${state?.img}.png`)} alt="instagram" className="md:h-12 h-10" />
              <div className="flex flex-col ">
                <span className="font-bold text-md pl-3">{state?.name}</span>
                <div className="flex items-center pt-1">
                  <img src={User} alt="tag" className="h-3 pl-3 pr-2 " />

                  <div className="text-xs text-gray-400">{state?.monthyUsers} Monthly Users</div>
                  <img src={Tag} alt="tag" className="h-3 md:pl-3 pl-1 pr-2" />

                  <div className="text-xs text-gray-400">Social Media</div>
                </div>
              </div>
            </div>
            <div>
              <button onClick={() => {setShowModal(8)}} className="bg-primary rounded-full md:text-medium text-xxs px-5 py-2 text-white">
                View Details
              </button>
            </div>
          </div>
          <div>
            <p className="text-primary font-bold text-lg mt-5 mb-2">
            {state?.heading}
            </p>
            <p className="text-gray-400 leading-7 ">
            {state?.discription}
            </p>
          </div>
        </div>
        <div className="md:col-span-4 md:mt-0 mt-5 col-span-12">
          <div className="bg-[#FCF1F2] h-full rounded-xl p-5">
            <div className="text-primary text-lg font-bold mb-2">
              Key Insights
            </div>
            <div className="grid grid-cols-2">
              {objofA.map((v, k) => (
                <div key={k} className="flex flex-col mt-2">
                  <div className="font-bold text-sm">{v.title}</div>
                  <div className="text-sm text-gray-400">{v.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <TopChoice choices={state?.topChoices} />
    </div>
  );
}

export default Detail;
